import RestaurantCardMediaButtons from './mediaButtons';

export { type RestaurantCardMediaButtonsProps } from './mediaButtons';

export default RestaurantCardMediaButtons;
